import { Announcement, AnnouncementFormData } from '../types';

const convertAnnouncement = (announcement: Announcement): AnnouncementFormData => {
  return {
    ItemID: announcement.ItemID,
    Title: announcement.Title || '',
    Description: announcement.Description || '',
    MoreLink: announcement.MoreLink || '',
    ExpireDate: announcement.ExpireDate || null,
  };
};

export default convertAnnouncement;
